import { create } from 'zustand';

export interface AccountPeriodStats {
  totalInteractions: number;
  views: number;
  reach: number;
  er: number | null;
}

/** Ключ кэша: аккаунт и границы периода в секундах (как их ждёт Instagram). */
export const statsKey = (accountId: string, since: string, until: string) => `${accountId}|${since}|${until}`;

type State = {
  stats: Record<string, AccountPeriodStats>;
  /** Ключи, по которым запрос идёт сейчас или упал: авто-загрузка их не повторяет. */
  loading: Record<string, boolean>;
  failed: Record<string, boolean>;
};

/**
 * Цифры Instagram в «Сводке» за период. Раньше колонки стояли «—» до ручного
 * «Обновить» и пропадали при переключении вкладки; теперь посчитанное живёт
 * здесь и догружается само.
 */
export const useAccountStatsCache = create<State>(() => ({ stats: {}, loading: {}, failed: {} }));

/** Какие аккаунты ещё надо загрузить за период (без кэша, без идущих и упавших запросов). */
export function accountsToLoad(
  ids: readonly string[],
  since: string,
  until: string,
  state: Pick<State, 'stats' | 'loading' | 'failed'>,
  force = false,
): string[] {
  return ids.filter((id) => {
    const key = statsKey(id, since, until);
    if (state.loading[key]) return false;
    if (force) return true;
    return !(key in state.stats) && !state.failed[key];
  });
}
